module.exports = __webpack_public_path__ + "img/other-invite.0eb63a42.svg";